export class DateHelpers {
    static readonly monthNames = [
        "January", "February", "March", "April",
        "May", "June", "July", "August",
        "September", "October", "November", "December"
    ];
    static ensureDate(date: Date): Date {
        if (date instanceof Date) {
            return date;
        } else if (typeof date === 'string' || typeof date === 'number') {
            return new Date(date);
        } else {
            throw new Error('Invalid date format');
        }
    }

    static formatDate(date: Date): string {
        date = this.ensureDate(date);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    static newFirstOfMonthDate(monthsAgo: number) {
        const now = new Date();
        let newFirstOfMonthDate = new Date(now.getFullYear(), now.getMonth(), 1); // Start with the first of the current month
        newFirstOfMonthDate.setMonth(newFirstOfMonthDate.getMonth() - monthsAgo);
        newFirstOfMonthDate.setDate(1); // set to first of the month
        newFirstOfMonthDate.setHours(0, 0, 0, 0); // set to midnight
        return newFirstOfMonthDate;
    }

    static daysAgoFromToday(dateString: string): number {
        const currentDate: Date = new Date();
        let date = new Date(dateString);

        const diffDate = currentDate.getTime() - date.getTime();

        return Math.ceil(diffDate / (1000 * 60 * 60 * 24));
    }
}